import { Flex, Divider } from '@chakra-ui/react';
import {
  HiOutlineTag,
  HiOutlineShoppingBag,
  // HiOutlineTruck, // TS "union type too complex" neste arquivo (Chakra v1) — usar FaTruck em vez disso
  HiOutlineUserGroup,
  HiOutlineDocumentText,
  HiOutlineDocumentReport,
  HiOutlineUserAdd,
  HiOutlineIdentification,
} from 'react-icons/hi';
import {
  // IoGlobeOutline,
  IoSettingsOutline,
} from 'react-icons/io5';
import { RiMoneyDollarCircleLine } from 'react-icons/ri';
import { FaMapMarkedAlt, FaChartPie, FaColumns, FaTruck, FaFileSignature, FaClipboardList } from 'react-icons/fa';
import { FiMessageCircle } from 'react-icons/fi';

import { SidebarItem } from '../SidebarItem';
import { useAuth } from '../../context/AuthContext';
import { useSidebar } from '../../context/SidebarContext';
import { ehLogistica } from '../../helpers/perfilLogistica';

export const SiderbarResponsive = () => {
  const { navSize, setNavSize } = useSidebar();
  const { user } = useAuth();
  const logistica = ehLogistica(user);

  // Cadastros ficam fora do menu da Logística (a rota também barra). Fica
  // numa constante à parte: inline no JSX abaixo estoura o "union type too
  // complex" do Chakra v1 neste arquivo.
  const itensDeCadastro = (
    <>
      <SidebarItem
        name="Categorias"
        nav={navSize}
        icon={HiOutlineTag}
        path="/listar/categoria"
      />
      <SidebarItem
        name="Produtos"
        nav={navSize}
        icon={HiOutlineShoppingBag}
        path="/listar/produto"
      />
      <SidebarItem
        name="Tabela de Preço"
        nav={navSize}
        icon={RiMoneyDollarCircleLine}
        path="/listar/tabela-preco"
      />

      <Divider
        w={navSize === 'large' ? '30px' : '220px'}
        transitionDuration="0.42s"
        ml={4}
      />
      {/* <SidebarItem
        name="Transportadoras"
        nav={navSize}
        icon={IoGlobeOutline}
        path="/listar/transportadora"
      />

      <SidebarItem
        name="Fretes"
        nav={navSize}
        icon={HiOutlineTruck}
        path="/listar/frete"
      /> */}
      {/* <Divider
        w={navSize === 'large' ? '30px' : '220px'}
        transitionDuration="0.42s"
        ml={4}
      /> */}
      {/* <SidebarItem
        name="Fornecedores"
        nav={navSize}
        icon={HiOutlineIdentification}
        path="/listar/fornecedor"
      /> */}
      <SidebarItem
        name="Clientes"
        nav={navSize}
        icon={HiOutlineUserGroup}
        path="/listar/cliente"
      />
      <Divider
        w={navSize === 'large' ? '30px' : '220px'}
        transitionDuration="0.42s"
        ml={4}
      />
      <SidebarItem
        name="Vendedores"
        nav={navSize}
        icon={HiOutlineUserAdd}
        path="/listar/vendedor"
      />
    </>
  );

  // O Assistente ESF abre o menu. A Logística não o vê: sem
  // vendedor vinculado, o assistente não mostra pedido nenhum (a rota também
  // barra). Constante à parte pelo mesmo motivo de `itensDeCadastro`.
  const itemDoAssistente = (
    <>
      <SidebarItem
        name="Assistente ESF"
        nav={navSize}
        icon={FiMessageCircle}
        path="/assistente"
      />
      <Divider
        w={navSize === 'large' ? '30px' : '220px'}
        transitionDuration="0.42s"
        ml={4}
      />
    </>
  );

  return (
    <Flex
      // p="5"
      zIndex="1"
      pos="fixed"
      top="0px"
      transitionDuration="0.3s"
      transitionTimingFunction="ease-in"
      overflow="hidden"
      h="100vh"
      w={navSize === 'large' ? '65px' : '250px'}
      flexDir="column"
      justify="space-between"
      bg="gray.900"
      border="1px solid"
      borderColor="gray.800"
      as="nav"
      onMouseEnter={() => {
        setNavSize('small');
      }}
      onMouseLeave={() => {
        setNavSize('large');
      }}
    >
      <Flex as="aside" flexDir="column" justifyContent="center" mt="100px">
        {/* <VStack spacing="6" align="flex-start"> */}

        {!logistica && itemDoAssistente}
        <SidebarItem
          name="Pedidos"
          nav={navSize}
          icon={HiOutlineDocumentReport}
          path="/listar/pedido"
        />
        <Divider
          w={navSize === 'large' ? '30px' : '220px'}
          transitionDuration="0.42s"
          ml={4}
        />
        {!logistica && (
          <SidebarItem
            name="Orçamentos"
            nav={navSize}
            icon={HiOutlineDocumentText}
            path="/listar/orcamento"
          />
        )}
        <Divider
          w={navSize === 'large' ? '30px' : '220px'}
          transitionDuration="0.42s"
          ml={4}
        />
        {!logistica && itensDeCadastro}
        {logistica && (
          <>
            <SidebarItem
              name="Produtos"
              nav={navSize}
              icon={HiOutlineShoppingBag}
              path="/listar/produto"
            />
            <SidebarItem
              name="Clientes"
              nav={navSize}
              icon={HiOutlineUserGroup}
              path="/listar/cliente"
            />
          </>
        )}
        <SidebarItem
          name="Mapa Cirúrgico"
          nav={navSize}
          icon={FaMapMarkedAlt}
          path="/mapa-cirurgico"
        />
        <SidebarItem
          name="Kanban"
          nav={navSize}
          icon={FaColumns}
          path="/mapa-cirurgico/kanban"
        />
        <SidebarItem
          name="Dashboard"
          nav={navSize}
          icon={FaChartPie}
          path="/mapa-cirurgico/dashboard"
        />
        <SidebarItem name="Em Rota" nav={navSize} icon={FaTruck} path="/entregas" />
        <SidebarItem
          name="Canhotos"
          nav={navSize}
          icon={FaFileSignature}
          path="/entregas/canhotos"
        />
        <SidebarItem
          name="Apontamentos"
          nav={navSize}
          icon={FaClipboardList}
          path="/apontamentos"
        />

        {/* <SidebarItem
          name="Agendamentos"
          nav={navSize}
          icon={AiOutlineCalendar}
          path="/listar/agendamento"
        /> */}
        {user?.role === 'ROLE_ADMIN' && (
          <>
            <Divider
              w={navSize === 'large' ? '30px' : '220px'}
              transitionDuration="0.42s"
              ml={4}
            />
            <SidebarItem
              name="Usuários"
              nav={navSize}
              icon={HiOutlineIdentification}
              path="/listar/usuario"
            />
            <SidebarItem
              name="Cadastro Empresas"
              nav={navSize}
              icon={IoSettingsOutline}
              path="/listar/parametrizacao"
            />
          </>
        )}
        {/* </VStack> */}
      </Flex>
    </Flex>
  );
};
